import {
  MineActions,
  MineHalfAmountPayload,
  MineDoubleAmountPayload,
  MineBetAmountPayload,
  MineQuantityChangePayload,
  MineResetPayload,
  MineBetVerifyAmountPayload,
  MinePlayAgainPayload,
} from './props';

export function requestMinesReset(): MineResetPayload {
  return {
    type: MineActions.Reset,
  };
}

export function getBetAmount(amount: string): MineBetAmountPayload {
  return {
    type: MineActions.GetAmount,
    payload: {
      amount,
    },
  };
}

export function setMineQuantity(
  mineQuantity: number,
): MineQuantityChangePayload {
  return {
    type: MineActions.SetMineQuantity,
    payload: {
      mineQuantity,
    },
  };
}

export function verifyAmount(amount: string): MineBetVerifyAmountPayload {
  return {
    type: MineActions.VerifyAmount,
    payload: {
      amount,
    },
  };
}

export function setHalfAmount(): MineHalfAmountPayload {
  return {
    type: MineActions.SetHalfAmount,
  };
}

export function setDoubleAmount(): MineDoubleAmountPayload {
  return {
    type: MineActions.SetDoubleAmount,
  };
}

export function playAgain(): MinePlayAgainPayload {
  return {
    type: MineActions.PlayAgain,
  };
}
